import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAssignmentCycles } from "../api/workApi";
import { openWorkFromCycle } from "../api/workApi";
import { startCycle } from "../api/workApi";

const WorkAssignments = () => {

  const navigate = useNavigate();

  const [cycles, setCycles] = useState([]);
  const [loading, setLoading] = useState(true);

  // ================= LOAD CYCLES =================
  const loadCycles = async () => {
    try {
      setLoading(true);
      const res = await getAssignmentCycles();
      setCycles(res.data || []);
    } catch (err) {
      console.error("Failed loading assignment cycles", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCycles();
  }, []);

  // ================= OPEN CYCLE =================
const openCycle = async (cycle) => {
  try {
    const res = await startCycle(cycle.AssignmentCycleID);

    const workId = res.data.WorkID;

    navigate(`/tasks/work/${workId}/areas`);

  } catch (err) {
    console.error(err);
  }
};

  // ================= GROUP BY ASSIGNMENT =================
  const groupedAssignments = cycles.reduce((acc, cycle) => {
    const key = cycle.AssignmentID;

    if (!acc[key]) {
      acc[key] = {
        assignmentName: cycle.AssignmentName,
        clientName: cycle.ClientName,
        cycles: []
      };
    }

    acc[key].cycles.push(cycle);
    return acc;

  }, {});

  // ================= UI =================

  if (loading) {
    return (
      <div className="p-6 text-gray-500">
        Loading assignments...
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6">

      <h1 className="text-2xl font-semibold">
        Assignments
      </h1>

      {Object.keys(groupedAssignments).length === 0 && (
        <div className="text-gray-500">
          No assignment cycles found
        </div>
      )}

      {Object.entries(groupedAssignments).map(
        ([assignmentId, assignment]) => (

          <div
            key={assignmentId}
            className="bg-white rounded-xl shadow p-5"
          >
            {/* Assignment Header */}
            <div className="mb-4">
              <h2 className="text-lg font-semibold">
                {assignment.clientName}
              </h2>

              <p className="text-gray-500">
                {assignment.assignmentName}
              </p>
            </div>

            {/* Cycles */}
            <div className="grid md:grid-cols-3 gap-4">

              {assignment.cycles.map((cycle) => (
                <div
                  key={cycle.AssignmentCycleID}
                  onClick={() => openCycle(cycle)}
                  className="
                    border rounded-lg p-4 cursor-pointer
                    hover:shadow-md hover:border-blue-500
                    transition
                  "
                >
                  <div className="font-medium">
                    {cycle.CycleName}
                  </div>

                  <div className="text-sm text-gray-500 mt-1">
                    {cycle.StartDate
                      ? new Date(cycle.StartDate).toLocaleDateString()
                      : ""}
                    {" - "}
                    {cycle.EndDate
                      ? new Date(cycle.EndDate).toLocaleDateString()
                      : ""}
                  </div>

                  <div className="mt-3">
                    <span
                      className={`
                        px-2 py-1 text-xs rounded
                        ${
                          cycle.Status === "Completed"
                            ? "bg-green-100 text-green-700"
                            : cycle.Status === "In Progress"
                            ? "bg-blue-100 text-blue-700"
                            : "bg-gray-100 text-gray-600"
                        }
                      `}
                    >
                      {cycle.Status}
                    </span>
                  </div>

                </div>
              ))}

            </div>
          </div>
        )
      )}
    </div>
  );
};

export default WorkAssignments;